var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 290,
    viewBox: "0 0 288 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175 111.251V290.001C173.916 290.001 172.832 290.001 171.747 290.001C138.601 288.27 113.096 259.443 113.096 225.785V174.123H63.1177C46.4559 174.029 30.4991 167.384 18.6906 155.621C6.88225 143.859 0.169134 127.922 0 111.251H175Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M287.5 0V290C265.171 289.993 243.63 281.714 227.009 266.75C217.479 258.007 209.894 247.345 204.749 235.46C199.604 223.575 197.014 210.734 197.149 197.777V89.6918H91.0198C67.1746 89.6559 44.2923 80.2464 27.2779 63.4803C10.2636 46.7141 0.471223 23.9258 0 0L287.5 0Z",
    fill: "url(#paint0_linear_3235_17428)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3235_17428",
    x1: 261.5,
    y1: 0,
    x2: -41.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EB683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EB683",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignTop);
export default __webpack_public_path__ + "static/media/design-top.0ffb60f6f576323b6aad71557cf02bc2.svg";
export { ForwardRef as ReactComponent };